import { render, staticRenderFns } from "./CreateDuplicationSalariesModal.vue?vue&type=template&id=0f456460&scoped=true&"
import script from "./CreateDuplicationSalariesModal.vue?vue&type=script&lang=ts&"
export * from "./CreateDuplicationSalariesModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDuplicationSalariesModal.vue?vue&type=style&index=0&id=0f456460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f456460",
  null
  
)

export default component.exports